module.exports = __webpack_public_path__ + "img/pcbg25.384473e1.jpg";